import { useAuth } from "providers/auth.provider";
import React, { useState } from "react";
import { sendMail } from "services/apf-api.service";

const packages = [
  {
    name: "Social Media Insights",
    price: "",
    features: ["Instagram", "Facebook", "more coming soon"],
  },
  {
    name: "Search",
    price: "",
    features: ["Google Analytics", "Google Search Console"],
  },
  {
    name: "Ecommerce",
    price: "",
    features: ["WooCommerce"],
  },
  {
    name: "Marketing",
    price: "",
    features: ["Mailchimp"],
  },
  {
    name: "Performance",
    price: "",
    features: ["Wordpress", "Akismet"],
  },
];

export default function NoSites() {
  const { idToken } = useAuth();

  const [selectedPackages, setSelectedPackages] = useState([]);
  const [email, setEmail] = useState("");
  const [loading, setLoading] = useState(false);
  const [success, setSuccess] = useState(false);
  const [error, setError] = useState("");

  const togglePackage = (pkgName) => {
    setSelectedPackages((prev) =>
      prev.includes(pkgName)
        ? prev.filter((name) => name !== pkgName)
        : [...prev, pkgName]
    );
  };

  const handleClick = async () => {
    if (!email) {
      setError("Please enter your email.");
      return;
    }

    setLoading(true);
    setError("");
    try {
      const subject = "Access Request for SaaS Dashboards";
      const html = `
        <p>User <strong>${email}</strong> has requested access to the following packages:</p>
        <ul>
          ${selectedPackages.map((pkg) => `<li>${pkg}</li>`).join("")}
        </ul>
      `;

      await sendMail(subject, html, idToken);
      setSuccess(true);
      setSelectedPackages([]);
      setEmail("");
    } catch (err) {
      console.error(err);
      setError("Failed to send request. Please try again.");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="min-h-screen bg-gray-50 flex flex-col items-center py-12 px-4 sm:px-6 lg:px-8">
      <div className="text-center max-w-md">
        <h1 className="text-3xl font-bold text-gray-900 mb-4">
          No dashboards found
        </h1>
        <p className="text-gray-600 mb-6">
          It looks like there are no available dashboards for your account yet.
          Select the packages you want and request access to get started!
        </p>

        {/* Email input */}
        <input
          type="email"
          placeholder="Enter your email"
          value={email}
          onChange={(e) => setEmail(e.target.value)}
          className="mb-4 w-full px-4 py-2 border rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500"
        />

        {/* Request Access Button */}
        <button
          disabled={selectedPackages.length === 0 || loading}
          onClick={handleClick}
          className={`w-full px-6 py-3 rounded-md transition ${
            selectedPackages.length === 0 || loading
              ? "bg-gray-400 cursor-not-allowed"
              : "bg-blue-600 text-white hover:bg-blue-700"
          }`}
        >
          {loading ? "Sending..." : "Request Access"}
        </button>

        {success && (
          <p className="mt-2 text-green-600">Request sent successfully!</p>
        )}
        {error && <p className="mt-2 text-red-600">{error}</p>}
      </div>

      {/* Package Cards */}
      <div className="mt-12 w-full max-w-6xl grid gap-6 sm:grid-cols-1 md:grid-cols-3">
        {packages.map((pkg) => {
          const isSelected = selectedPackages.includes(pkg.name);
          return (
            <div
              key={pkg.name}
              onClick={() => togglePackage(pkg.name)}
              className={`cursor-pointer bg-white shadow-md rounded-lg p-6 flex flex-col justify-between hover:shadow-xl transition border-2 ${
                isSelected ? "border-blue-600" : "border-transparent"
              }`}
            >
              <h2 className="text-xl font-semibold mb-2">{pkg.name}</h2>
              <p className="text-gray-500 mb-4">{pkg.price}</p>
              <ul className="mb-4 space-y-2">
                {pkg.features.map((feature, idx) => (
                  <li key={idx} className="text-gray-700">
                    • {feature}
                  </li>
                ))}
              </ul>
            </div>
          );
        })}
      </div>
    </div>
  );
}
